import React, { Component } from 'react';
import { FamDiagram } from 'basicprimitivesreact';
import { GroupByType, PageFitMode, Enabled } from 'basicprimitives';
import "../styles/FamilyTree.css"

var photos = {
  a: 'https://img.freepik.com/free-vector/smiling-young-man-illustration_1308-174401.jpg?semt=ais_hybrid'
};

class FamilyTree extends Component {
  render() {
    const template = {
        name: "customTemplate",
        itemSize: { width: 150, height: 220 },
        onItemRender: ({ context: item }) => (
          <div className={!item.title ? "hide-node" : "custom-node" }>
            <img src={item.image} alt={item.title} className="node-image" />
            <div className="node-details">
              <h4 className="node-title">{item.title}</h4>
              <p className="node-description">{item.description}</p>
              <p className="node-phone">📞 +234800000000</p>
              <p className="node-phone">🎂 9 may 1990</p>
            </div>
          </div>
        ),
      };
    const config = {
      pageFitMode: PageFitMode.None,
      cursorItem: 0,
      linesWidth: 1,
      linesColor: "#A2966B",
      hasSelectorCheckbox: Enabled.False,
      normalLevelShift: 20,
      dotLevelShift: 0,
      lineLevelShift: 20,
      normalItemsInterval: 16,
      dotItemsInterval: 0,
      templates: [template],
      defaultTemplateName: "customTemplate",
      lineItemsInterval: 10,
    //   arrowsDirection: GroupByType.Parents,
        
      showExtraArrows: false,
      items: [
				{ id: 1, title: "Thomas Williams", label: "Thomas Williams", description: "Grandpa", image: photos.a },
				{ id: 2, title: "Mary Spencer", label: "Mary Spencer", description: "Grandma ",image: photos.a },
				{ id: 4, parents: [1, 2], title: "Brad Williams", label: "Brad Williams", description: "Son", image: photos.a },
				{ id: 5, parents: [1, 2], title: "Mike Kirby", label: "Mike Kirby", description: "Son", image: photos.a},
				{ id: 6, title: "Lynette Maloney", label: "Lynette Maloney", description: "Wife", image: photos.a },
				{ id: 11, parents: [6, 4], title: "Steven Powell", label: "Steven Powell", description: "Son", image: photos.a },
				{ id: 7, title: "Sara Kemp", label: "Sara Kemp", description: "Wife", image: photos.a },
				{ id: 12, parents: [5, 7], title: "John Smith", label: "John Smith", description: "Son", image: photos.a },
				{ id: 8, parents: [6, 4], title: "Leon Kemp", label: "Leon Kemp", description: "Daughter", image: photos.a },
				{ id: 13, title: "David Kirby", label: "David Kirby", description: "Husband", image: photos.a },
				{ id: 14, parents: [5, 7],title: "Mary Kirby", label: "Mary Kirby", description: "Daughter", image: photos.a },
                { id: 15, parents: [13, 14], description: "", label: "", title: null },

      ],
      onItemRender: ({ context: item }) => (
        <div className="custom-node">
          <img src={item.image} alt={item.title} className="node-image" />
          <div className="node-details">
            <h4 className="node-title">{item.title}</h4>
            <p className="node-description">{item.description  + "great"}</p>
          </div>
        </div>
      )
    };

    return <>
      <div className="ftreeButton">
        <button>Connect to Family Tree</button>
      </div>
      <div className="placeholder">
        <FamDiagram centerOnCursor={true} config={config} />
      </div>
      <div className="ftreeButton2">
        <button>Connect to Family Tree</button>
      </div>
    </>
  }
}

export default FamilyTree;